import React from 'react'

import View from './View'

const TemplateWall = ({
  setActiveTemplate,
  templateOptions,
  currentTemplate,
  templates,
  getAllTemplates,
  deleteTemplate,
  getTemplateVariables,
}) => (
  <View
    setActiveTemplate={setActiveTemplate}
    templateOptions={templateOptions}
    currentTemplate={currentTemplate}
    templates={templates}
    getAllTemplates={getAllTemplates}
    deleteTemplate={deleteTemplate}
    getTemplateVariables={getTemplateVariables}
  />
)

export default TemplateWall
